<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="tasks.data"
      :sort-by="'id'"
      :sort-desc="true"
    >
      <template v-slot:item.date_from="{ item }">
        {{ item.date_from | dateFormat }}
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip :color="item.status_color" :text-color="item.status_font_color">
          {{ item.status }}
        </v-chip>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="text-center">
          <v-list-item @click="$emit('show', item)">
            <v-list-item-title>
              <v-icon class="mr-1" small>mdi-eye</v-icon>
              {{ $t('ITEM.VIEW') }}
            </v-list-item-title>
          </v-list-item>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { dateFormat } from '@/modules/_global/filters';

export default {
  name: 'OrdersTasksList',

  filters: {
    dateFormat
  },

  props: {
    tasks: {
      type: Object,
      default: () => ({
        data: []
      })
    }
  },

  data: () => ({}),

  computed: {
    ...mapState(['loading']),
    headers() {
      return [
        {
          text: this.$t('TASK.ID'),
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('EMPLOYEES.ITEM'),
          sortable: true,
          value: 'employee'
        },
        {
          text: this.$t('ITEM.DATE'),
          sortable: true,
          value: 'date_from'
        },
        {
          text: this.$t('ITEM.TIME'),
          sortable: true,
          value: 'time'
        },
        {
          text: this.$t('TASKS.REPORT_TIME'),
          sortable: true,
          value: 'reported_time'
        },
        {
          text: this.$t('ITEM.DURATION'),
          sortable: true,
          value: 'duration'
        },
        {
          text: this.$t('PROFILE.STATUS'),
          sortable: true,
          value: 'status'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  },

  watch: {
    options: {
      handler() {
        this.refreshData();
      },
      deep: true
    }
  },

  created() {
    this.unwatch = this.$store.watch(
      state => state.localization.lang,
      () => {
        const lang = this.$store.state.localization.lang;

        if (lang) {
          this.refreshData();
        }
      }
    );
  },

  destroyed() {
    this.unwatch();
  },

  methods: {
    refreshData() {
      this.$emit('refresh');
    }
  }
};
</script>
